export default "__VITE_ASSET__81323929__"